import React, { useEffect, useState } from "react";
// import InputMask from 'react-input-mask'
import { useQueryClient } from "@tanstack/react-query";
import { useModal } from "../../../../hooks/ModalContext";
import { Button } from "../../../generics/button";
import { useChatWhatsApp } from "../../../../context/ChatWhatsAppContext";
import { useAuth } from "../../../../context/AuthContext";
import { useFila } from "../../../../context/FilaContext";
import { useDividas } from "../../../../context/DividasContext";
import { Telefones } from "../../../../types/devedor-interface";
import { apiOperador } from "../../../../services/api";

interface AddTelefoneProps {
  isHibrido?: boolean
}


export const AddTelefone = ({ isHibrido }: AddTelefoneProps) => {
  const { onClose } = useModal();
  const [telefone, setTelefone] = useState('')
  const { devedorFilaSelected, getChatId, } = useFila()
  const { devedorCadastro, devedor, setDevedor } = useDividas();
  const { criarChat, setChatIdHibrido } = useChatWhatsApp()
  const { cookies } = useAuth()
  const queryClient = useQueryClient()

  let botId: string = "5efc8f75d2d46a2504b59a19";

  const listaSMS = devedorCadastro?.telefones?.telefonecliente && devedorCadastro?.telefones?.telefonecliente.length > 0 ? devedorCadastro?.telefones.telefonecliente.filter(item => (item.tipo_telefone.includes('Movel') && (item.situacaotelefone === 'Valido' || item.situacaotelefone === 'Contactado') && item.whats === 'true')) : [] as Telefones[]
  const lista = listaSMS && listaSMS?.length > 0 ? listaSMS?.sort((a, b) => {
    const order = {
      "Movel Particular": 1,
      "Movel Comercial": 2,
      "Movel Referencia": 3,
      "Movel Conjuge": 4,
      "Fixo Residencial": 5,
      "Fixo Comercial": 6,
      "Fixo Referencia": 7,
      "Fixo Conjuge": 8,
      "Fixo Trabalho Conjuge": 9,
      "Outros": 10
    };


    // Prioridade por tipo de telefone e situação
    let priorityA = order[a.tipo_telefone] || 11;
    let priorityB = order[b.tipo_telefone] || 11;

    // Verificar se é "contactado" ou "valido" e ajustar a prioridade

    if (a.situacaotelefone.includes('Invalido')) priorityA = 12
    if (b.situacaotelefone.includes('Invalido')) priorityB = 12

    if (a.situacaotelefone !== "Valido" && a.situacaotelefone !== "Contactado") priorityA -= 0.2;
    if (b.situacaotelefone !== "Valido" && b.situacaotelefone !== "Contactado") priorityB -= 0.2;

    if (a.situacaotelefone === "Contactado") priorityA -= 0.8;
    if (b.situacaotelefone === "Contactado") priorityB -= 0.8;

    if (a.situacaotelefone === "Valido") priorityA -= 0.5;
    if (b.situacaotelefone === "Valido") priorityB -= 0.5;

    // Ordenar com base na prioridade e, em caso de empate, pelo tipo de telefone
    if (priorityA === priorityB) {
      return a.tipo_telefone.localeCompare(b.tipo_telefone);
    }

    return priorityA - priorityB;
  }) : [] as Telefones[];


  function removerDuplicadosPorPropriedade(array: Telefones[]) {
    return array.filter((obj, index, self) =>
      index === self.findIndex((el) => el['telefone'] === obj['telefone'])
    );
  }


  const listaTelefone: Telefones[] = lista && lista?.length > 0 ? removerDuplicadosPorPropriedade(listaSMS) : [] as Telefones[]

  // value.replace(/\D/g, '')

  async function createChat(providerChatId: string) {
    const token = cookies?.whatsapp?.token || ''
    const { chatID } = await criarChat(providerChatId, botId, token)
    if (isHibrido) {
      setChatIdHibrido(chatID)
      onClose();
      return
    }
    if (!devedorFilaSelected.id_queue && !isHibrido) {
      const { data } = await apiOperador.put("/cliente/conversa", {
        params: {
          id: devedor.id_debtor,
          id_conversa: chatID,
        },
      });
      setDevedor({
        ...devedor,
        id_chat: data.cliente[0].id_chat,
      });
    }
    if (devedorFilaSelected.id_queue) {
      await getChatId(Number(devedorFilaSelected.id_queue), chatID);
      await queryClient.refetchQueries({ queryKey: ["atendimento"] });
    }
    await getChatId(Number(devedorFilaSelected.id_queue), chatID)
    await queryClient.refetchQueries({ queryKey: ['atendimento'] })
    onClose();
  }

  function formatarTelefone(telefone: string) {
    telefone = telefone?.replace(/\D/g, '');
    telefone = telefone?.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
    return telefone;
  }

  return (
    <>
      <div className="flex flex-col items-center px-1">
        <p className="mb-4 mt-2 text-center text-lg text-gray-600">
          Escolha um telefone para começar o a conversa:
        </p>
        {
          listaTelefone && listaTelefone.length === 0 ? <p className="text-gray-600  my-4">Não há telefones móveis com WhatsApp cadastrados </p> : <select className="w-full rounded-sm bg-gray-200 p-2 text-gray-600 outline-none text-xs my-4" onChange={(e) => setTelefone(e.target.value)}>
            <optgroup>
              <option value=""></option>
              {
                listaTelefone && listaTelefone?.length > 0 && listaTelefone.map(tel => (

                  <option key={tel.id_telefone} value={`55${tel.telefone}`}>{formatarTelefone(tel?.telefone)} - {tel.situacaotelefone} - {tel.tipo_telefone}</option>
                ))
              }
            </optgroup>
          </select>
        }
        <div className="flex w-full items-center gap-2">
          <button
            className="h-8 w-full rounded-md bg-red-600 text-center text-white"
            onClick={() => onClose()}
          >
            Cancelar
          </button>
          <Button
            name="Confirmar"
            onClick={() => {
              createChat(telefone)
              // createChat('5511992076161', '64b6cd6d5639a8f6b058a755')
              // createChat('5565992050909', '64b6cd6d5639a8f6b058a755')
            }}
          />
        </div>
      </div>
    </>
  );
};
